// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2344":"d990b416","8014":"b3350ec7","8371":"c7855118"}[chunkId] + ".chunk.css";
};